export const budgetColors = [
    ['#0a6273', '#009578', '#8fbe44'],
    ['#695DF1', '#695DF1CC', '#695DF199'],
    ['#DA55F0', '#DA55F0CC', '#DA55F099'],
]